import React from "react";
import { useLocalFileActionsContext } from "../contexts/LocalFileActionsContext";
import styles from "../styles/GitChangeListStyles";

const GitChangesList = ({ changes, onRevert }) => {
  const { addTab } = useLocalFileActionsContext();
  const handleShowDiff = (change) => {
    const state =
      change.currentContent != change.originalContent ? "update" : "synced";
    addTab(
      // Use proper full path to match file from the FileTree
      change.file,
      change.currentContent || "",
      state,
      change.originalContent || null
    );
  };

  return (
    <div style={styles.container}>
      <h4>Git Changes</h4>
      <ul style={styles.list}>
        {changes.map((change, index) => (
          <li key={index} style={styles.listItem}>
            <div style={styles.fileInfo}>
              <span style={styles.fileText}>
                {change.file} - {change.state}
              </span>
              <button
                onClick={() => onRevert(change.file)}
                style={styles.revertButton}
              >
                Revert
              </button>
              {change.state === "updated" && (
                <button
                  onClick={() => handleShowDiff(change)}
                  style={styles.showDiffButton}
                >
                  Show Diff
                </button>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GitChangesList;
